export default class LoadMore {

    constructor() {
        this.settings = {
            $postsList : $(".posts-list")
        };

        this.bindUIActions();
    }

    bindUIActions() {

        if (this.settings.$postsList != null) {

            let postsList = this.settings.$postsList; // The container element that holds the list of posts
            let loadNr = $('#js-nr-posts-default').val(); // The number of posts to load
            let loadMoreBtn = $(".js-load-more"); // The button that triggers the loading of more posts

            function postTypeList() {
                // Remove hidden class from all the posts
                $('.post-single').removeClass('hidden');

                postsList.find('.post-single').each(function (index) {

                    // Hide posts that have a higher index than the number of posts to load
                    if (index >= loadNr) {
                        $(this).addClass('hidden');
                    }
                });
            }

            postTypeList();

            // Hide the load more button if there are no more posts to load initially
            if (postsList.find('.hidden').length === 0) {
                loadMoreBtn.removeClass('btn');
                loadMoreBtn.addClass('hidden');
            }

            // Load more posts when the button is clicked
            loadMoreBtn.on('click',  (e) => {

                const $this = e.currentTarget;

                let morePosts = postsList.find('.hidden'); // The posts that are currently hidden
                let counter = 0; // Counter to keep track of the number of posts that have been shown
                morePosts.each(function () {

                    // Stop the loop when the number of posts that have been shown is equal to the number of posts to load
                    if (counter >= loadNr) {
                        return false;
                    }

                    // Increment the counter
                    counter++;

                    // Show the post
                    $(this).removeClass('hidden');
                });

                // Hide the load more button if there are no more posts to load
                if (postsList.find('.hidden').length === 0) {
                    $this.classList.remove('btn');
                    $this.classList.add('hidden');
                }
            });

        }

    }
};

new LoadMore();